/*
     Title: Constant for REJECT_TYPE
     Description: Constant for REJECT_TYPE
     Author: Iqbal Hossain
     Date: 06-January-2022
     Modified: 10-January-2022
*/

export const FETCH_REJECT_TYPE = 'FETCH_REJECT_TYPE';
export const TOGGLE_REJECT_TYPE_SIDEBAR = 'TOGGLE_REJECT_TYPE_SIDEBAR';
export const TOGGLE_REJECT_TYPE_STATUS = 'TOGGLE_REJECT_TYPE_STATUS';
export const FETCH_REJECT_TYPE_BY_QUERY = 'FETCH_REJECT_TYPE_BY_QUERY';
export const ADD_REJECT_TYPE = 'ADD_REJECT_TYPE';
export const DELETE_REJECT_TYPE = 'DELETE_REJECT_TYPE';
export const FETCH_REJECT_TYPE_BY_ID = 'FETCH_REJECT_TYPE_BY_ID';
export const UPDATE_REJECT_TYPE = 'UPDATE_REJECT_TYPE';
export const DELETE_REJECT_TYPE_BY_RANGE = 'DELETE_REJECT_TYPE_BY_RANGE';

/** Change Log
 * 10-Jan-2022(Iqbal): Add TOGGLE_REJECT_TYPE_SIDEBAR, FETCH_REJECT_TYPE_BY_QUERY, ADD_REJECT_TYPE, DELETE_REJECT_TYPE, FETCH_REJECT_TYPE_BY_ID, UPDATE_REJECT_TYPE, DELETE_REJECT_TYPE_BY_RANGE
 */
